import { render } from "./AddStock.vue?vue&type=template&id=023d678c&scoped=true"
import script from "./AddStock.vue?vue&type=script&lang=js"
export * from "./AddStock.vue?vue&type=script&lang=js"

import "./AddStock.vue?vue&type=style&index=0&id=023d678c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023d678c"]])

export default __exports__